import { schema } from 'normalizr';

import { Worklist } from 'models';

export const worklistEntity = new schema.Entity<Worklist>('worklists');
